export const clearParam = (param: string) => {
  return param.replace(/&lt;/g, "").replace(/&gt;/g, "").replace(/[<>]/g, "");
};
